// extracted by mini-css-extract-plugin
export default {"wrapper":"attach-media-module--wrapper--fUy39"};